import { Point } from 'app/contracts/Geometry';
import { DistanceBetweenTwoPoints } from 'app/chrome/mouse/DistanceBetweenTwoPoints';

/** https://stackoverflow.com/questions/8515900/how-to-constrain-movement-within-the-area-of-a-circle */
export class ConstrainAroundCircle {
	private _distanceRuler: DistanceBetweenTwoPoints = new DistanceBetweenTwoPoints();
	private _center: Point;
	private _radius: number;
	private _distance: number;
	private _x: number;
	private _y: number;
	private _radians: number;

	public setConstraints(center: Point, radius: number): void {
		this._center = center;
		this._radius = radius;
	}

	public limit(mousePosition: Point) {
		this._distance = this._distanceRuler.measure(mousePosition, this._center);
		if (this._distance <= this._radius) {
			return { x: mousePosition.x, y: mousePosition.y };
		} else {
			this._x = mousePosition.x - this._center.x;
			this._y = mousePosition.y - this._center.y;
			this._radians = Math.atan2(this._y, this._x);
			return {
				x: Math.cos(this._radians) * this._radius + this._center.x,
				y: Math.sin(this._radians) * this._radius + this._center.y
			};
		}
	}
}
